import React from "react";
import get from "lodash/get";
import { Link } from "@quintype/components";
import { object, string } from "prop-types";

import CardImage from "../../atoms/cardimage";
import Headline from "../../atoms/headline";

import { getHeadline } from "../../utils/utils";
import translate from "../../translate";

import "./also-read.m.css";

const AlsoRead = ({ story, element, publisherName }) => {
  const linkedStoryId = get(element, ["metadata", "linked-story", "id"], "");
  const linkedStory = get(story, ["linked-stories", linkedStoryId], {});
  const linkedStorySlug = get(story, ["linked-stories", linkedStoryId, "slug"], "");
  const headline = getHeadline(linkedStory);

  if (!Object.values(linkedStory).length) return null;

  return (
    <div styleName="also-read">
      <div styleName="title">{translate(publisherName, "also_read")}</div>

      <Link styleName="content" href={linkedStorySlug}>
        <Headline text={headline} headerType={3} story={story} />
        <CardImage story={linkedStory} aspectRatio={[16, 9]} imageType="image16x9" widths={[120]} />
      </Link>
    </div>
  );
};

AlsoRead.propTypes = {
  story: object,
  element: object,
  publisherName: string,
};

export default AlsoRead;
